module.exports = __webpack_public_path__ + "media/gili/boats-7f4bc89d.jpg";